<template>
	<div>
		<v-divider></v-divider>

		<v-card-text>
			<v-subheader>
				This section allows you to outline the company core values.
			</v-subheader>

			<v-data-table hide-headers disable-initial-sort :headers="headers" :items="coreValues" hide-actions class="elevation-1">
				<template slot="items" slot-scope="props">
					<tr>
						<td class="text-xs-left">{{ props.item.text }}</td>
						<td class="justify-center px-0">
							<v-icon small class="mr-2" @click="editCoreValue(props.item)">
								edit
							</v-icon>
							<v-icon small @click="deleteCoreValue(props.item)">
								delete
							</v-icon>
						</td>
					</tr>
				</template>
			</v-data-table>
		</v-card-text>
	</div>
</template>

<script>
	import CoreValueEditor from '@/components/CoreValueEditor';

	export default {
		components: {
			CoreValueEditor
		},
		props: {
			coreValues: {
				required: true,
				type: Array
			}
		},
		data() {
			return {
				headers: [
					{ text: 'Text', value: 'text' },
					{ text: '', value: 'actions', sortable: false }
				]
			};
		},
		methods: {
			editCoreValue(item) {
				this.$emit('onEditCoreValue', item);
			},
			deleteCoreValue(item) {
				this.$emit('onDeleteCoreValue', item);
			}
		}
	};
</script>

<style></style>
